<template>
  <page-blank-layout :title="title">
    <template v-slot:btn-right>
      <v-btn icon @click="refresh" :loading="isLoading">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-simple-table :loading="isLoading">
          <template v-slot:default>
            <thead>
              <tr class="text-center">
                <th></th>
                <th class="text-center black--text">เวลาดำเนินการ</th>
                <th class="text-center black--text">เลือก</th>
                <th class="text-center black--text">อัตราต่อรอง</th>
                <th class="text-center black--text">การเดิมพัน</th>
                <th class="text-center green black--text">ชนะ/แพ้</th>
                <th class="text-center black--text">สถานะ</th>
                <th class="text-center black--text">ตัวแทนแบ่งสู้/คอมมิชชั่น</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="19" class="text-center">
                  <v-progress-linear indeterminate></v-progress-linear>
                </td>
              </tr>
              <tr v-else v-for="(item) in detail" :key="item[0]">
                <td v-for="(td, i) in item"
                  :key="item[0] + '-' + i" class="text-right">
                  <span v-html="td"></span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

  </page-blank-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageBlankLayout from '../../layouts/PageBlankLayout.vue'
export default {
  props: {
    ufa_user: {
      type: String,
      required: true
    }
  },
  components: {
    PageBlankLayout,
  },
  data() {
    return {
      title: this.$t('winlost.text'),
      isLoading: false,
      startDatePickerShow: false,
      endDatePickerShow: false,
      startDateTh: '',
      endDateTh: '',
      filter: {}
    }
  },
  created() { },
  async mounted() {
    this.isLoading = true
    await this.onSearch({})
    this.isLoading = false
  },
  methods: {
    ...mapActions('outstand', ['getDetail']),
    showDetail(account) {
      this.ufa_user = account.replace(/\*/g, '')
      this.openDialog = true
    },
    async onSearch(){
      this.isLoading = true
      await this.getDetail(this.ufa_user)
      this.isLoading = false
    },
    async refresh() {
      this.isLoading = true
      await this.getDetail(this.ufa_user)
      this.isLoading = false
    }
  },
  computed: {
    ...mapGetters('outstand', ['detail']),
    ...mapGetters('user', ['profile'])
  },
  watch: {
    startDateTh(val) {
      if (!val) this.filter['start_date'] = ''
    },
    endDateTh(val) {
      if (!val) this.filter['end_date'] = ''
    }
  }
}
</script>

<style>
</style>
